module.exports = __webpack_public_path__ + "static/media/home-bg-computer.6aafad0c.jpg";